/**
 * GmRaceConfig — single visible toggle surface for the /gmrace URL.
 *
 * /gmrace is the one-click entry to the GM Race lobby. Players land in
 * a dedicated staging map (gm_race_lobby) and auto-join the race event.
 * DJ (admin) sees a "Start Race" button; everyone else sees the
 * participant list + "Waiting for DJ to start..." message.
 *
 * Wiring:
 *   - applyModeUrlCoercion.ts → coerceModeUrl injects ?map=gm_race_lobby
 *   - GameRoomServices.ts     → on room create with gm_race_lobby, auto-creates race event
 *   - RaceLobbyWindow.tsx     → lobby window (ToolWindow, draggable framed rows, start button)
 *   - GmEventRaceEngine.ts    → existing race engine (unchanged)
 *
 * @see docs/design/gm/GM_RACE_MVP_PTR_CARD.md
 */

export const GM_RACE_CONFIG = {
  // Cookie/cache hygiene — same as /brawl + /pve + /lobby.
  resetOnLoad: true,

  // Skip the quick class cards (DJ 2026-07-06): racers get a RANDOM class
  // sprite per visit (pack variety) — the class is ability-irrelevant
  // because the race installs the uniform racer-loadout overlay + ability
  // allowlist at staging. Explicit ?class=… deep links still win.
  // autoClassPicker: the auto-pick runs through the PreGameFlow funnel (its
  // ?class auto-create effect) so real Twitch accounts work — the synthetic
  // pickCharacter=0 spawn is localhost-only.
  autoClass: 'random' as const,
  autoClassPicker: true,

  // HUD overrides — match /lobby. live-lobby preset is the clean social-hub
  // viewport (target-frame on, no dev-only panels).
  preset: 'live-lobby' as const,
  skipSplash: true,

  // Twitch-identity surface (DJ 2026-07-06): the race is a stream event —
  // participants race under their real Twitch names, and DJ's Start-Race
  // admin tier comes from his Twitch session (ADMIN_USER_IDS allowlist).
  // forceLogin injects ?skipLogin=0 on PUBLIC hosts so the Twitch-only
  // AuthScreen gates entry; localhost + explicit ?skipLogin=1 (the race
  // runtime probes) keep the dev shortcut. See coerceModeUrl.forceLogin.
  skipLogin: false,
  forceLogin: true,
} as const;
